function bootstrap() {
  subMenu();
  // studentSwitch();
  slickSliderInit();
  fitVidsInit();
  // pdfIcons();
}

$(document).ready(function(){
  bootstrap();
});

function slickSliderInit() {
  $('.slickslider').slick({
    slidesToShow: 6,
    autoplay: true,
    autoplaySpeed: 2000,
    mobileFirst: true,
    arrows: false
  });
  // $('.mobileslider').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   mobileFirst: true,
  //   responsive: [{
  //     breakpoint: 768,
  //     settings: "unslick"
  //   }]
  // });
}

function subMenu() {
  $('.subpage-menu .subsubmenu-show').on('click', function(){
    $(this).closest('.subpage-menu-item').addClass('is-active');
  });
  $('.subpage-menu .subsubmenu-hide').on('click', function(){
    $(this).closest('.subpage-menu-item').removeClass('is-active');
  });
}

// function studentSwitch() {
//   let path = window.location.pathname;
//   // if (path.substring(0,9) == '/student/') {
//   if (path.substring(0,13) == '/studierende/') {
//     // path = path.slice(8);
//     path = path.slice(12);
//   } else {
//     // path = '/student' + path;
//     path = '/studierende' + path;
//   }

//   let prefetched;

//   $.ajax({
//     url: path,
//     cache: true,
//     success: function(html){
//       $('#switch').removeClass('is-hidden');
//       prefetched = html;
//     },
//     error: function(err) {
//       console.log('ajax switch error: ' + err.statusText);
//     }
//   });
// }


function fitVidsInit () {
  $('iframe').each(function() {
    var src = $(this).attr('src')
    if (src.indexOf("vimeo") >= 0 || src.indexOf("youtube") >= 0) {
      $(this).parent().fitVids();
    }
  })
}

// function pdfIcons () {
//   $('.sidebox a').each(function(){
//     var href = $(this).attr('href')
    
//   })
// }